export function downloadDocument(name: string, url: string): Promise<void> {
    return new Promise((resolve) => {
        const element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', name);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        setTimeout(() => resolve(), 500);
    });
}
